import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  selector: 'aux-investigator-forecast-link',
  template: `
    <a class="btn--hyperlink px-0 text-sm" [routerLink]="[link]">{{ label }}</a>
  `,
})
export class InvestigatorForecastLinkComponent {
  @Input() label!: number | string;
  @Input() link!: string;
}
